module.exports = __webpack_public_path__ + "static/media/img-ab.024b3d3b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-ab.jpg
// module id = 30
// module chunks = 0